import Avatar from 'components/Avatar'
import { observer } from 'mobx-react'
import * as React from 'react'
import styles from './WorkspaceOpportunityListItem.sass'
import WorkspacePostingOpportunityViewModel from '../../../WorkspacePostingOpportunityViewModel'
import OpportunityItem, {
  OpportunityItemAvatarInfo,
  OpportunityItemAvatar,
  OpportunityItemInfo,
  OpportunityItemTitle,
  OpportunityItemSubtitle,
  ForwardIcon,
} from '../../../../components/OpportunityItem'
import WorkspaceOpportunityDetailsViewModel from '../../../WorkspaceOpportunityDetailsViewModel'
import cx from 'classnames'

interface OpportunityListItemProps {
  opportunity: WorkspacePostingOpportunityViewModel
  detailsVM: WorkspaceOpportunityDetailsViewModel
}

export default observer(function WorkspaceOpportunityListItem({
  opportunity: vm,
  detailsVM,
}: OpportunityListItemProps) {
  const { opportunity, disabled } = vm
  return (
    <OpportunityItem
      onSelect={() => detailsVM.select(vm)}
      selected={detailsVM.selected?.opportunityId === vm.opportunityId}
      data-test={'workspace-opportunity-list-item-' + vm.opportunityId}
      disabled={disabled}
    >
      <OpportunityItemAvatarInfo>
        <OpportunityItemAvatar
          disabled={disabled}
          avatar={
            <Avatar
              subject={{
                avatar: undefined,
              }}
            />
          }
        />
        <OpportunityItemInfo>
          <OpportunityItemTitle
            title={'Firm Opportunity'}
            disabled={disabled}
          />
          <OpportunityItemSubtitle>
            <span className={styles.jobTypes}>
              {opportunity.jobTypes.join(', ')}
            </span>
            {' | '}
            <span>
              {opportunity.requirements.join(', ') || 'No description'}
            </span>
          </OpportunityItemSubtitle>
        </OpportunityItemInfo>
      </OpportunityItemAvatarInfo>
      {opportunity.isApplicant && (
        <span
          className={cx(styles.applicationStatus, styles[opportunity.status])}
        >
          {opportunity.isActive && 'Applied to opportunity'}
          {opportunity.isInReview && 'Application in review'}
        </span>
      )}
      <ForwardIcon
        selectColor={opportunity.isInReview ? 'green' : 'blue'}
        disabled={disabled}
      />
    </OpportunityItem>
  )
})
